import { FC } from 'react';
import { useInfiniteQuery } from 'react-query';
import type { InAppNotification } from 'types/InAppNotification';
import {
  NOTIFICATIONS_COUNT_PER_PAGE,
  IN_APP_NOTIFICATIONS_QUERY,
} from 'components/in-app-notifications/InAppNotifications.constants';
import InAppNotificationsApi from 'app/api/inAppNotifications';

export type InAppNotificationsRequestParams = {
  data: InAppNotification[];
  isError: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isLoadingMore: boolean;
  canLoadMore: boolean;
  loadMore(): void;
};

type Props = {
  children(params: InAppNotificationsRequestParams): JSX.Element;
};

const InAppNotificationsRequest: FC<Props> = ({ children }) => {
  const {
    data,
    isError,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery(
    [IN_APP_NOTIFICATIONS_QUERY.RETRIEVE],
    ({ pageParam = 1 }) => InAppNotificationsApi.get(pageParam),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.length < NOTIFICATIONS_COUNT_PER_PAGE
          ? undefined
          : allPages.length + 1,
    },
  );

  return children({
    data: data?.pages.flat() ?? [],
    isLoading,
    isError,
    isFetching,
    isLoadingMore: isFetchingNextPage,
    loadMore: () => {
      fetchNextPage();
    },
    canLoadMore: !!hasNextPage,
  });
};

export default InAppNotificationsRequest;
